import iconFilter from "../../../img/icons/icon-filter.png";

export const FilterBtnV1 = (props) => {
  return (
    <img
      className={[`sort_icon_table`]}
      style={{ opacity: props.active ? 1 : 0.4 }}
      src={iconFilter}
      alt="фильтр"
      onClick={props.onClick}
    />
  );
};
